import { render, staticRenderFns } from "./CTerrorism.vue?vue&type=template&id=7891d9ba"
import script from "./CTerrorism.vue?vue&type=script&lang=js"
export * from "./CTerrorism.vue?vue&type=script&lang=js"
import style0 from "./CTerrorism.vue?vue&type=style&index=0&id=7891d9ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports